var _defs, _path, _path2, _g, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShutOffValve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .b, .c {\r\n        fill: #fff;\r\n      }\r\n\r\n      .c {\r\n        stroke: #000;\r\n        stroke-miterlimit: 10;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m18.7,44.7c-.5,0-1-.4-1-1v-.6h-2.9v10.5h2.9v-.5c0-.5.4-1,1-1h9.8v-7.4h-9.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m62.3,43.1v.6c0,.5-.4,1-1,1h-10.4v7.4h10.4c.5,0,1,.4,1,1v.5h2.9v-10.5h-2.9Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "50.9 44.7 50.9 39.2 28.5 39.2 28.5 44.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.4 44.7 50.4 44.7 50.4 39.7 29 39.7 29 44.7 28 44.7 28 38.7 51.4 38.7 51.4 44.7"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m28.5,52.1v2.8c0,1.4,1.2,2.6,2.6,2.6h17.2c1.4,0,2.6-1.1,2.6-2.6v-2.8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m44.9,22.5h-10.4c-1.7,0-3.1,1.4-3.1,3.1v1.4l.4.1c.6.1.9.6.9,1.2v7.9h3v3.2h7.9v-3.3h3.2v-7.9c0-.5.3-1,.8-1.1l.4-.1v-1.5c0-1.6-1.4-3-3.1-3Zm-9.1,12.2c0,.3-.2.5-.5.5s-.5-.2-.5-.5v-7c0-.3.2-.5.5-.5s.5.2.5.5v7Zm4.4,0c0,.3-.2.5-.5.5s-.5-.2-.5-.5v-7c0-.3.2-.5.5-.5s.5.2.5.5v7Zm4.4,0c0,.3-.2.5-.5.5s-.5-.2-.5-.5v-7c0-.3.2-.5.5-.5s.5.2.5.5v7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShutOffValve);
export default __webpack_public_path__ + "static/media/shutOffValve.c47b5f269d149f5f79478922de3a77fb.svg";
export { ForwardRef as ReactComponent };